module.exports = __webpack_public_path__ + "static/media/particle-lab.455f978e.png";